import { DEFAULT_CITY_SLUG, DEFAULT_CITY_SLUG_MONETKA } from '@lentau/city/shared/constants';
import { environmentBrand } from '@lentau/ui-kit/core/environments/environment.brand';
import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';

interface DefaultCitySlugFactory {
  create(): string;
}

class MonetkaDefaultCitySlugFactory implements DefaultCitySlugFactory {
  public create(): string {
    return DEFAULT_CITY_SLUG_MONETKA;
  }
}

class CommonDefaultCitySlugFactory implements DefaultCitySlugFactory {
  public create(): string {
    return DEFAULT_CITY_SLUG;
  }
}

export const getDefaultCitySlugFactory: () => DefaultCitySlugFactory = () => {
  const factoryByBrand: Partial<Record<RetailBrands, DefaultCitySlugFactory>> = {
    [RetailBrands.MONETKA]: new MonetkaDefaultCitySlugFactory(),
  };

  return factoryByBrand[environmentBrand.BRAND] || new CommonDefaultCitySlugFactory();
};
